// extracted by mini-css-extract-plugin
module.exports = {"time":"styles_time__LE1gl","inputTime":"styles_inputTime__3B3C-"};